import React from 'react';
import { Box, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './modalCharacteristics.module.scss';
import { ModalCharacteristicsProps } from '../../interfaces';

const ModalCharacteristics: React.FC<ModalCharacteristicsProps> = ({
    open,
    onClose,
    selectedVehicleId,
    publication
}) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    border: '1px solid #E5E5E5',
                    borderRadius: 2,
                    p: 3,
                    width: '70%',
                    maxWidth: 500,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}
            >
                <Box
                    sx={{
                        color: '#1D1B2080',
                        position: 'absolute',
                        top: 20,
                        right: 20,
                        cursor: 'pointer',
                        zIndex: 10,
                    }}
                    onClick={onClose}
                >
                    <CloseIcon />
                </Box>
                <h2 className={styles.modalTitle}>Características adicionales</h2>
                {(() => {
                    const selectedVehicle = publication?.vehicles?.find((v: any) => v._id === selectedVehicleId);
                    return selectedVehicle?.additional_characters?.length > 0 ? (
                        selectedVehicle.additional_characters.map((category: any) => (
                            <div key={category.code} className={styles.categoryBlock}>
                                <p className={styles.categoryTitle}>{category.name}</p>
                                {category.value
                                    .filter((item: any) => item.value === true)
                                    .map((item: any, index: number) => (
                                        <div
                                            key={item.code}
                                            className={`${styles.characteristicRow} ${index % 2 !== 0 ? styles.rowGray : ''}`}
                                        >
                                            <span className={styles.characteristicName}>{item.name}</span>
                                            <span className={styles.characteristicValue}>Sí</span>
                                        </div>
                                    ))}
                            </div>
                        ))
                    ) : (
                        <p>No hay características adicionales para esta versión</p>
                    )
                })()}
            </Box>
        </Modal>
    );
};

export default ModalCharacteristics;
